import { action, payload } from 'ts-action'
import { IUser } from 'models/User'
import { IError, IPayload } from 'models/Global'

export const GetUser = action('GetUser', payload<IPayload<IUser>>())
export const GetUserErrors = action('GetUserErrors', payload<IError>())
export const UserFetching = action('UserFetching', payload<boolean>())
export const UpdateUser = action('UpdateUser', payload<IPayload<IUser>>())
export const ClearUserReducer = action('ClearUserReducer')
